export default "__VITE_ASSET__kkiA1qVU__"